import type { FC } from 'react'
import { useEffect } from 'react'

type DocumentTitleProps = {
  title?: string
}

export const DocumentTitle: FC<DocumentTitleProps> = ({ title }) => {
  useEffect(() => {
    if (title) {
      document.title = title
    }
  }, [title])

  return null
}
